module.exports = __webpack_public_path__ + "static/karate-754f3fdaa95a96adef5f5b39a5b2e66c.jpg";